import "../scss/app.scss";

import * as jQuery from "jquery"
window.$  = jQuery;

import "jquery-contextmenu";
import moment from "moment";

import 'bootstrap'

import "select2";


window.moment = moment;

import "daterangepicker";
import "lodash";
import "color-pick";

// AdminKit (required)
import "./modules/bootstrap";
import "./modules/sidebar";
import "./modules/theme";
import "./modules/feather";
import "./modules/data-tables"

// Charts
import "./modules/chartjs";

// Forms
import "./modules/flatpickr";

// Maps
import "./modules/vector-maps";

import "./modules/TemplateBuilder";
import "./modules/site";

import 'bootstrap5-multi-level-dropdown/js/bootstrap5-multi-level-dropdown-module.js';

import * as utils from './modules/Utils';
window.utils = utils;

import Swal from 'sweetalert2';
window.Swal = Swal;


import "bootstrap-select";